module.exports = __webpack_public_path__ + "img/thumb_31.a5e57978.jpg";